import React from 'react';
import PropTypes from 'prop-types';
import { ToggleButton, ToggleButtonGroup, Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField, Box } from '@mui/material';

/**
 * Selector rápido de rango de fechas para el dashboard.
 * Soporta los rangos: hoy, ayer, 7d, 30d y custom (future).
 * Dispara onChange con un objeto { key, startDate, endDate }.
 */
export default function RangeSelector({ value, onChange }) {
  const [open, setOpen] = React.useState(false);
  const [tempStart, setTempStart] = React.useState('');
  const [tempEnd, setTempEnd] = React.useState('');
  const handleChange = (_event, newKey) => {
    if (!newKey) return; // evita des-selección

    const today = new Date();
    const end = new Date(today.getFullYear(), today.getMonth(), today.getDate());
    let start = new Date(end);

    // Si selecciona personalizado, abrir diálogo
    if (newKey === 'custom') {
      setOpen(true);
      // precargar fechas actuales
      const todayISO = new Date().toISOString().split('T')[0];
      setTempEnd(todayISO);
      setTempStart(todayISO);
      return;
    }

    switch (newKey) {
      case 'today':
        // mismo día
        break;
      case 'yesterday':
        start.setDate(start.getDate() - 1);
        end.setDate(end.getDate() - 1);
        break;
      case '7d':
        start.setDate(start.getDate() - 6);
        break;
      case '30d':
        start.setDate(start.getDate() - 29);
        break;
      default:
        // custom future
        break;
    }

    const format = (d) => d.toISOString().split('T')[0];
    onChange({
      key: newKey,
      startDate: format(start),
      endDate: format(end),
    });
  };

  return (
    <>
    <ToggleButtonGroup
      exclusive
      size="small"
      value={value}
      onChange={handleChange}
      sx={{ mb: 2 }}
    >
      <ToggleButton value="today">Hoy</ToggleButton>
      <ToggleButton value="yesterday">Ayer</ToggleButton>
      <ToggleButton value="7d">7 días</ToggleButton>
      <ToggleButton value="30d">30 días</ToggleButton>
      <ToggleButton value="custom">Personalizado</ToggleButton>
    </ToggleButtonGroup>

    {/* Diálogo para rango personalizado */}
    <Dialog open={open} onClose={() => setOpen(false)}>
      <DialogTitle>Selecciona rango personalizado</DialogTitle>
      <DialogContent>
        <Box display="flex" gap={2} sx={{ mt: 1 }}>
          <TextField
            label="Desde"
            type="date"
            InputLabelProps={{ shrink: true }}
            value={tempStart}
            onChange={(e) => setTempStart(e.target.value)}
          />
          <TextField
            label="Hasta"
            type="date"
            InputLabelProps={{ shrink: true }}
            value={tempEnd}
            onChange={(e) => setTempEnd(e.target.value)}
          />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => setOpen(false)}>Cancelar</Button>
        <Button
          variant="contained"
          onClick={() => {
            setOpen(false);
            if (tempStart && tempEnd) {
              onChange({ key: 'custom', startDate: tempStart, endDate: tempEnd });
            }
          }}
        >
          Aplicar
        </Button>
      </DialogActions>
    </Dialog>
    </>
  );
}

RangeSelector.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};
